import { useEffect, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import { toast } from "react-toastify"
import { loaderStart, loaderStop } from "../features/HomeMaster"
import { ScoreCard } from "./ScoreCard"

export const TradeMarket = () => {
    const [datam, setdata] = useState([])
    const [dataF, setdataF] = useState([])
    const [resultPop, setResultPop] = useState()
    const [selectedEventType, setSelectedEventType] = useState("All");
    const [selectedEventName, setSelectedEventName] = useState("All");

    const loader = useSelector(state => state.homeMaster?.loader)
    const dispatch = useDispatch()

    const fetchTradeDetails = async () => {
        const data = await fetch('https://postg.9xxbet.com/api/v1/admin/gettrademarketsall')
        const data2 = await fetch('https://magicapi.4magics.com/api/v1/admin/gettrademarketsall')
        let resData = await data.json()
        let resData2 = await data2.json()
        let setss = []
        let fulldata = []
        for (let i = 0; i < resData.data.length; i++) {
            const element = resData.data[i];
            fulldata.push(element)
            let isexist = setss.find(a => a.eventName === element.eventName)
            if (isexist) {
                let isMidExist = isexist.data.find(a => a.marketId == element.marketId)
                if (!isMidExist) {
                    isexist.data.push(element)
                }
            } else {
                setss.push({
                    eventName: element.eventName,
                    data: [element]
                })
            }
        }
        for (let i = 0; i < resData2.data.length; i++) {
            const element = resData2.data[i];
            fulldata.push(element)
            let isexist = setss.find(a => a.eventName === element.eventName)
            if (isexist) {
                let isMidExist = isexist.data.find(a => a.marketId == element.marketId)
                if (!isMidExist) {
                    isexist.data.push(element)
                }
            } else {
                setss.push({
                    eventName: element.eventName,
                    data: [element]
                })
            }
        }
        setdata(setss)
        setdataF(fulldata)
    }
    const [resultData, setResultData] = useState({
        winerId: "",
    })

    const openResultPop = (data) => {
        setResultPop(data)
    }

    const giveResultToPOSTGFANCY = async (mid, wid) => {
        const bodyData =
        {
            "mid": mid,
            "sid": wid,
        }
        try {
            const res2 = await fetch('https://postg.9xxbet.com/api/v1/result/postresultfancy', {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify(bodyData)
            })
            const data2 = await res2.json()
            if (data2.status === 'success') {
                toast.success("result updated to 4MAGIC")
            }
        } catch (error) {

        }
        try {
            const res3 = await fetch('https://magicapi.4magics.com/api/v1/result/postresultfancy', {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify(bodyData)
            })
            const data2 = await res3.json()
            if (data2.status === 'success') {
                toast.success("result updated to BESTFAIR")
            }
        } catch (error) {

        }
        try {
            const res22 = await fetch('https://masterpg.9xxbet.com/api/v1/result/postresultfancy', {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify(bodyData)
            })
            const data2 = await res22.json()
            if (data2.status === 'success') {
                toast.success("result updated to MASTERSERVER")
            }
        } catch (error) {

        }
    }
    const giveResultToPOSTGNORMAL = async (mid, wid) => {
        const bodyData =
        {
            "mid": mid,
            "sid": wid,
        }
        try {
            const res2 = await fetch('https://postg.9xxbet.com/api/v1/result/postresultnormal', {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify(bodyData)
            })
            const data2 = await res2.json()
            if (data2.status === 'success') {
                toast.success("result updated to 4MAGIC")
            }
        } catch (error) {

        }
        try {
            const res3 = await fetch('https://magicapi.4magics.com/api/v1/result/postresultnormal', {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify(bodyData)
            })
            const data2 = await res3.json()
            if (data2.status === 'success') {
                toast.success("result updated to BESTFAIR")
            }
        } catch (error) {

        }
        try {
            const res22 = await fetch('https://masterpg.9xxbet.com/api/v1/result/postresultnormal', {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify(bodyData)
            })
            const data2 = await res22.json()
            if (data2.status === 'success') {
                toast.success("result updated to MASTERSERVER")
            }
        } catch (error) {

        }
    }

    const onResultSelectChange = (e) => {
        setResultData({ ...resultData, winerId: e.target.value })
    }
    const saveResult = async (mid, wid, name) => {
        if (window.confirm("Please confirm winner that is " + wid + " for " + name)) {
            if (window.confirm("Please confirm again your winner id = " + wid + " and runner = " + name)) {
                giveResultToPOSTGFANCY(mid, wid)
                return
            }
        }
        return
    }
    const saveResultToNormal = async (mid, wid, name) => {
        if (window.confirm("Please confirm winner that is " + wid + " for " + name)) {
            if (window.confirm("Please confirm again your winner id = " + wid + " and runner = " + name)) {
                giveResultToPOSTGNORMAL(mid, wid)
                return
            }
        }
        return
    }

    const onResultDChange = (e) => {
        setResultData({ ...resultData, [e.target.name]: e.target.value })
    }

    useEffect(() => {
        fetchTradeDetails()
        let a = setInterval(() => {
            fetchTradeDetails()
        }, 50000);
        return () => {
            clearInterval(a)
        }
    }, [])
    const eventTypes = ["All"];

    datam?.forEach(d => {
        d.data.forEach(a => {
            if (!eventTypes.includes(a.eventTypeName)) {
                eventTypes.push(a.eventTypeName);
            }
        });
    });

    const eventNames = ["All"];

    datam?.forEach(d => {
        d.data.forEach(a => {
            if (
                (selectedEventType === "All" || a.eventTypeName === selectedEventType) &&
                !eventNames.includes(a.eventName)
            ) {
                eventNames.push(a.eventName);
            }
        });
    });

    const eventId = dataF.find(x => x.eventName == selectedEventName)?.eventId
    let eventTypeId = dataF.find(x => x.eventTypeName == selectedEventType || x.eventName == selectedEventName)?.eventTypeId

    eventTypeId = eventTypeId == 0 ? 4 : eventTypeId == 13 ? 4 : eventTypeId

    return (
        <>
            <div style={{ marginTop: '50px' }} className=' page-body-wrapper overflow-auto'>
                <div className="main-panel overflow-auto">
                    <div className="content-wrapper overflow-auto">
                        <div className="row overflow-auto">
                            {
                                selectedEventName != "All" && eventId && eventTypeId ? <ScoreCard eventId={eventId} sportId={eventTypeId} /> : <></>
                            }
                            <div className="mb-3">
                                {
                                    eventTypes.map(type => (
                                        <button
                                            key={type}
                                            className={`btn me-2 ${selectedEventType === type ? "btn-primary" : "btn-outline-primary"}`}
                                            onClick={() => setSelectedEventType(type)}
                                        >
                                            {type}
                                        </button>
                                    ))
                                }
                            </div>
                            <div className="mb-3">
                                <select
                                    className="form-select w-auto"
                                    value={selectedEventName}
                                    onChange={(e) => setSelectedEventName(e.target.value)}
                                >
                                    {
                                        eventNames.map(name => (
                                            <option key={name} value={name}>{name}</option>
                                        ))
                                    }
                                </select>
                            </div>
                            <div className="col-md-12 overflow-auto">
                                <table class="table table-striped table-bordered overflow-auto">
                                    <thead className="table-dark">
                                        <th>MarketName <button onClick={() => fetchTradeDetails()}>
                                            Refresh
                                        </button> </th>
                                        <th>EventName</th>
                                        <th>Result</th>
                                    </thead>
                                    <tbody>
                                        {
                                            datam?.map(d => (
                                                d.data
                                                    .filter(a =>
                                                        (selectedEventType === "All" || a.eventTypeName === selectedEventType) &&
                                                        (selectedEventName === "All" || a.eventName === selectedEventName)
                                                    )
                                                    .map(a => (
                                                        <tr>
                                                            <td style={{display: 'flex', justifyContent: 'space-between', flexWrap: 'nowrap'}}>
                                                                <div>{a.marketName}</div>
                                                                <div>

                                                                    <button data-bs-toggle="modal" data-bs-target="#result-popup" onClick={() => {
                                                                        setResultData({
                                                                            winerId: ""
                                                                        })
                                                                        openResultPop(a)
                                                                    }} _ngcontent-mck-c63="" className="btn btn-primary text-white" fdprocessedid="2870zc">
                                                                        Close
                                                                    </button>
                                                                    <button data-bs-toggle="modal" data-bs-target="#delete-popup" onClick={() => {
                                                                        setResultData({
                                                                            winerId: ""
                                                                        })
                                                                        openResultPop(a)
                                                                    }} _ngcontent-mck-c63="" className="btn btn-danger text-white" fdprocessedid="2870zc">
                                                                        Delete
                                                                    </button>
                                                                </div>
                                                            </td>
                                                            <td>{a.eventName}</td>
                                                            <td>{a.eventTypeName}</td>
                                                            <td>{new Date(a.marketTime).toLocaleString()}</td>
                                                            <td>
                                                            </td>
                                                        </tr>
                                                    ))
                                            ))
                                        }
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
                <div _ngcontent-tpi-c33="" id="delete-popup" tabindex="-1" aria-labelledby="delete-popup" class="modal fade" aria-modal="true" role="dialog" style={{ display: "none" }}>
                    <div _ngcontent-tpi-c33="" class="modal-dialog">
                        <div _ngcontent-tpi-c33="" class="modal-content">
                            {
                                loader ? (
                                    <div>Loading...</div>
                                ) : (
                                    <>
                                        <div _ngcontent-tpi-c33="" class="modal-header text-dark">
                                            <h1 _ngcontent-tpi-c33="" id="book-deal-popupLabel" class="modal-title fs-5 text-uppercase">{resultPop && resultPop.stMarketName || resultPop?.marketName}</h1>
                                            <button _ngcontent-tpi-c33="" type="button" data-bs-dismiss="modal" aria-label="Close" class="btn-close"></button>
                                        </div>
                                        <div _ngcontent-tpi-c33="" class="modal-body">
                                            <div className=''>Do you want to delete this market?</div>
                                            <button onClick={() => {
                                                dispatch(loaderStart())
                                                saveResult(resultPop.stMarketID || resultPop.marketId, "Delete", resultPop.stMarketName || resultPop?.marketName).then((data) => {
                                                    if (data?.success) {
                                                        toast.success("Result has been uploaded successfully")
                                                    } else {
                                                        toast.error("Server error")
                                                    }
                                                    dispatch(loaderStop())
                                                })
                                            }} className='btn btn-danger'>Delete</button>
                                        </div>
                                    </>
                                )
                            }
                        </div>
                    </div>
                </div>
                <div _ngcontent-tpi-c33="" id="result-popup" tabindex="-1" aria-labelledby="result-popup" class="modal fade" aria-modal="true" role="dialog" style={{ display: "none" }}>
                    <div _ngcontent-tpi-c33="" class="modal-dialog">
                        <div _ngcontent-tpi-c33="" class="modal-content">
                            {
                                loader ? (
                                    <div>Loading...</div>
                                ) : (
                                    <>
                                        <div _ngcontent-tpi-c33="" class="modal-header text-dark">
                                            <h1 _ngcontent-tpi-c33="" id="book-deal-popupLabel" class="modal-title fs-5 text-uppercase">{resultPop && resultPop.stMarketName || resultPop?.marketName}</h1>
                                            <button _ngcontent-tpi-c33="" type="button" data-bs-dismiss="modal" aria-label="Close" class="btn-close"></button>
                                        </div>
                                        <div _ngcontent-tpi-c33="" class="modal-body">
                                            {
                                                resultPop?.eventTypeName !== 'Fancy' ? (
                                                    <div className='my-3'>
                                                        <select onChange={onResultSelectChange} name="winerId" id="">
                                                            <option value="0" disabled selected>Select winner from below</option>
                                                            {
                                                                JSON.parse(resultPop?.runners ? resultPop?.runners : '[]')?.map((x) => (
                                                                    <option value={x.selectionId}>{x.runnerName}</option>
                                                                ))
                                                            }
                                                            <option value="Delete">Delete</option>
                                                        </select>
                                                        {/* <input type="number" onChange={onResultDChange} value={resultData.winerId} name='winerId' /> */}
                                                    </div>
                                                ) : <div>
                                                    <input type="number" onChange={onResultDChange} value={resultData.winerId} name='winerId' />
                                                </div>
                                            }
                                            <button onClick={() => {
                                                dispatch(loaderStart())
                                                resultPop?.eventTypeName !== 'Fancy' ? saveResultToNormal(resultPop.stMarketID || resultPop.marketId, resultData.winerId, resultPop.marketName) :
                                                    saveResult(resultPop.stMarketID || resultPop.marketId, resultData.winerId, resultPop.stMarketName || resultPop.marketName).then((data) => {
                                                        if (data?.success) {
                                                            toast.success("Result has been uploaded successfully")
                                                        } else {
                                                            toast.error("Server error")
                                                        }
                                                    })
                                                dispatch(loaderStop())
                                            }} data-bs-dismiss="modal" className='btn btn-danger'>Close</button>
                                        </div>
                                    </>
                                )
                            }
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}
